// extracted by mini-css-extract-plugin
export default {"headerLabel":"headerLabel-c4a7","multiLineLabel":"multiLineLabel-25e9","unAnimateText":"unAnimateText-b48d","highlight":"highlight-df70","error":"error-e04c"};